var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSentToPolice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "31px",
    height: "31px",
    viewBox: "0 0 124.000000 124.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,124.000000) scale(0.100000,-0.100000)",
    fill: "#040B44",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M494 1225 c-207 -45 -370 -182 -448 -378 -126 -317 29 -675 347 -801 317 -126 674 29 801 347 125 316 -29 675 -344 800 -120 47 -238 58 -356 32z m271 -308 l120 -32 3 -149 c3 -170 -5 -207 -63 -286 -38 -52 -154 -146 -193 -156 -49 -13 -208 121 -253 213 -22 45 -24 60 -24 213 l0 165 120 32 c66 17 131 31 145 31 14 0 79 -14 145 -31z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508 863 l-98 -25 0 -127 c0 -111 3 -132 23 -176 24 -50 108 -136 160 -164 34 -18 58 -7 135 64 85 77 102 122 102 276 l0 127 -105 26 c-57 14 -108 26 -112 25 -4 0 -52 -12 -105 -26z m154 -132 c13 -23 24 -31 45 -31 50 0 56 -13 22 -46 -29 -27 -30 -32 -24 -82 l7 -54 -40 24 -41 23 -45 -23 -46 -22 5 25 c3 14 7 35 10 48 3 17 -5 33 -31 58 -30 29 -32 34 -17 41 10 3 30 7 46 7 22 1 31 9 49 47 24 49 25 48 60 -15z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSentToPolice);
export default __webpack_public_path__ + "static/media/SentToPolice.13ad00540a82c6bd495611e801ded44d.svg";
export { ForwardRef as ReactComponent };